module.exports = __webpack_public_path__ + "static/media/micro_atm.2b87dc87.svg";